// extracted by mini-css-extract-plugin
export default {"wrapper":"vQ7uk8"};